import { slugifyUser } from "~/utils/string";
import Link from "next/link";
import { FaTwitter } from "react-icons/fa";
import { api } from "~/utils/api";
import { Unpacked } from "~/types/helpers";
import UserImage from "../users/UserImage";
import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { SocialLinks } from "~/types/UserTypes";
import { cn } from "~/utils/fontsConfig";
import { CustomizableLayout } from "~/types/CustomizableLayout";

type HostedByProps = {
    user: Unpacked<EventBySlugOutput["hosts"]>["user"];
    includeSocials?: boolean;
    className?: string;
    customization?: CustomizableLayout;
};

const HostedBy = (props: HostedByProps) => {
    const includeSocials = props.includeSocials ?? true;
    const twitterLink =
        props.user.socialLinks &&
        ((props.user.socialLinks as SocialLinks)?.x as string);

    if (!props.user)
        return (
            <div className="flex items-center justify-start">
                There are no hosts for this event yet
            </div>
        );
    return (
        <div
            className={cn(
                `
                mt-2
                flex
                flex-row
                items-center
                justify-between
            `,
                includeSocials ? "w-[250px]" : "w-[200px]",
                props.className,
            )}
        >
            <Link
                className={cn(
                    "group flex cursor-pointer flex-row",
                    props.customization?.linkClassName,
                )}
                href={`/profile/${slugifyUser(props.user)}`}
            >
                <div>
                    <UserImage user={props.user} iconSize={44} />
                </div>
                <div
                    className={cn(
                        "ml-2 flex flex-row items-center transition-[color] duration-300 group-hover:text-secondary",
                        props.customization?.linkClassName,
                    )}
                >
                    {props.user.name}
                </div>
            </Link>
            {(includeSocials as boolean) && (twitterLink as string) && (
                <button
                    className={cn(
                        "transition-[color] duration-300 hover:text-secondary",
                        props.customization?.linkClassName,
                    )}
                    onClick={() => {
                        window.open(`${twitterLink}`, "_blank");
                    }}
                >
                    <FaTwitter />
                </button>
            )}
        </div>
    );
};

export default HostedBy;
